'use strict';

var Utils = require('../utils/utils');

// Constructor
var Scrollspy = function() {

  var self = this;
  var $window = $(window);

  self.config = {
    'parent'  :  '[data-scroll-spy-parent]',
    'item'    :  '[data-scroll-spy]'
  }

  var $item = $(self.config.item);

  self.scrollListener = function() {

    $(self.config.parent).each(function(i) {
      var $this = $(this);
      var _$item = $this.find($item);
      var lastId;
      var sections = _$item.map(function() {
        var $this = $(this);
        var $section = $($this.attr('data-scroll-spy'));
        if ($section.length) {
          return $section;
        }
      });

      $window.on('scrollSpyInitialCheck scroll.scrollSpy' + i, new Utils().throttle(function() {
        var $this = $(this);
        var halfViewportHeight = $this.height() / 2.5;
        var currSection = sections.map(function() {
          var offsetTop = $(this)[0].getBoundingClientRect().top;
          if (offsetTop !== 0 && offsetTop < halfViewportHeight) {
            return this;
          }
        });

        currSection = currSection[currSection.length - 1];

        var id = currSection && currSection.length ? currSection[0].id : '';

        if (lastId !== id && id !== '') {
          lastId = id;

          _$item
            .removeClass('is-active')
            .each(function() {
              var $this = $(this);
              var attr = $this.attr('data-scroll-spy');

              if (attr === '#' + id) {
                $this.addClass('is-active');
              }
            });
        }
      }, 300));
      $window.trigger('scrollSpyInitialCheck');
    });
  }

  self.init = function() {
    self.scrollListener();
  }
};

module.exports = Scrollspy;
